import { getSessionToken as getDescopeSessionToken } from '@descope/nextjs-sdk/client';
import { createAuthenticationMiddleware } from '../../middlewares/auth/descope-auth-middleware';
import type { AuthProvider } from './types';

export const descopeAuthProvider: AuthProvider = {
  type: 'descope',
  createAuthenticationMiddleware,
  getSessionToken: () => {
    try {
      return getDescopeSessionToken() ?? null;
    } catch {
      return null;
    }
  },
};
